import { Visits } from '../models/skyclub.interfaces';

export const VisitsScaleHighMocks: Visits = {
  min: '15',
  ofLabel: 'of',
  max: '15',
  scale: 'HIGH',
  label: 'Delta Sky Club Visits available',
  tooltipInfo:
    '<p>Your eligible American Express Card offers 15 Delta Sky Club visits, from February 1 through January 31 of the following year. All entries made within a single 24-hour period are considered one visit. Spend $75,000 on your eligible card to gain unlimited access. <a href="/us/en/delta-sky-club/access" target="_blank">Terms apply.<span class="sr-only">opens in a new tab</span></a></p>'
};

export const VisitsScaleLowMocks: Visits = {
  min: '4',
  ofLabel: 'of',
  max: '15',
  scale: 'LOW',
  label: 'Delta Sky Club Visits available',
  tooltipInfo:
    '<p>Your eligible American Express Card offers 15 Delta Sky Club visits, from February 1 through January 31 of the following year. All entries made within a single 24-hour period are considered one visit. Spend $75,000 on your eligible card to gain unlimited access. <a href="/us/en/delta-sky-club/access" target="_blank">Terms apply.<span class="sr-only">opens in a new tab</span></a></p>'
};

export const VisitsScaleZeroMocks: Visits = {
  min: '0',
  ofLabel: 'of',
  max: '15',
  scale: 'ZERO',
  label: 'Delta Sky Club Visits available',
  tooltipInfo:
    '<p>Your eligible American Express Card offers 15 Delta Sky Club visits, from February 1 through January 31 of the following year. All entries made within a single 24-hour period are considered one visit. Spend $75,000 on your eligible card to gain unlimited access. <a href="/us/en/delta-sky-club/access" target="_blank">Terms apply.<span class="sr-only">opens in a new tab</span></a></p>'
};
